import { createSlice } from '@reduxjs/toolkit';
import { appLs } from '../../utils/localStorage';

const lsForum = appLs.getObject('forum');

const slice = createSlice({
  name: 'forum',
  initialState: {
    postType: lsForum,
  },
  reducers: {
    setPostType: (state, { payload: { postType } }) => {
      state.postType = postType;
    },
  },
});

export const { setPostType } = slice.actions;

export default slice.reducer;

export const selectPostType = (state) => state.forum.postType;
